<template>
  <div class="e-block-wrap">
    <div class="e-block">
      <div class="e-block__scroll" :style="{ minHeight: containerHeight }">
        <div class="e-selector-block">
          <div class="e-block__title e-block__title--mb16">{{ title }}</div>
          <div class="e-block__text e-block__text--mb16">{{ text }}</div>
          <div class="e-row e-row--gutters">
            <div class="e-col-6 e-col-sm-12" v-for="(fixture, index) in fixtures" :key="index">
              <div class="fixture-item">
                <div class="e-row e-row--align-center e-row--gutters">
                  <div class="e-col-auto">
                    <img :src="fixture.img" :alt="fixture.title" class="fixture-item__img">
                  </div>
                  <div class="e-col">
                    <div class="fixture-item__title">{{ fixture.title }}</div>
                    <div class="fixture-item__text">{{ fixture.flowRate }}</div>
                  </div>
                  <div class="e-col-auto">
                    <div class="e-product__value">
                      <div class="e-row e-row--justify-center">
                        <div class="e-col-auto">
                          <div class="e-product__quantity e-product__quantity--decrease" @click="decrease(fixture)"></div>
                        </div>
                        <div class="e-col-auto">
                          <div class="e-product__quantity-value">{{ fixture.quantity }}</div>
                        </div>
                        <div class="e-col-auto">
                          <div class="e-product__quantity e-product__quantity--increase" @click="increase(fixture)"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="e-row e-row--gutters">
            <div class="e-col e-col-sm-12">
              <div class="e-block__form-label">Flow Rate (GPM)</div>
              <input type="text"
                     class="e-input"
                     @keypress="isNumber"
                     v-model="value">
              <div class="e-input__hint" v-html="hint" />
            </div>
            <div class="e-col"></div>
          </div>
        </div>
        <tip v-if="currentQuestion.tip" :text="currentQuestion.tip" />
      </div>
    </div>
    <div class="e-bottom-navbar">
      <div class="e-row e-row--gutters">
        <div class="e-col-auto e-col-sm-6 e-order-sm-2">
          <button class="e-btn e-btn--prev" @click.prevent="previous">Previous</button>
        </div>
        <div class="e-col-auto e-col-sm-6 e-order-sm-3">
          <button class="e-btn e-btn--help e-btn--no-text" @click.prevent="nextQuestion(needHelp)"><span>Help</span></button>
        </div>
        <div class="e-col"></div>
        <div class="e-col-auto e-col-sm-12 e-order-sm-1">
          <button class="e-btn e-btn--next" @click.prevent="proceed(value)" :disabled="disabledBtn">Proceed</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { needHelp } from '@/utils/residential-flow';
import Tip from '@/components/ui/Tip.vue';

export default {
  components: {
    Tip,
  },
  name: 'FlowRate',
  data() {
    return {
      value: 0,
      needHelp,
    };
  },
  mounted() {
    const link = document.querySelector('.e-assistance');
    if (link) {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.nextQuestion(needHelp);
      });
    }
  },
  computed: {
    ...mapState(['selectedFlow', 'containerHeight']),
    ...mapGetters(['currentQuestion']),
    fixtures() {
      return this.currentQuestion?.fixtures || [];
    },
    title() {
      return this.currentQuestion?.title || '';
    },
    text() {
      return this.currentQuestion?.text || '';
    },
    hint() {
      return this.currentQuestion?.hint || '';
    },
    disabledBtn() {
      return !this.value || +(this.value) <= 0;
    },
  },
  methods: {
    ...mapActions(['previousQuestion', 'nextQuestion', 'addParamToFilter']),
    previous() {
      this.previousQuestion();
    },
    proceed(value) {
      this.addParamToFilter({ name: this.currentQuestion.paramName, value });
      this.nextQuestion(this.currentQuestion.nextId);
    },
    decrease(fixture) {
      if (fixture.quantity > 0) {
        fixture.quantity -= 1;
      }
    },
    increase(fixture) {
      fixture.quantity += 1;
    },
    isNumber(evt) {
      evt = (evt) || window.event;
      const charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
  },
  watch: {
    fixtures: {
      handler() {
        const value = +(this.fixtures.reduce((acc, cur) => {
          acc += cur.quantity * cur.flowRateValue;
          return acc;
        }, 0).toFixed(1));
        this.value = value === Math.floor(value) ? +(value.toFixed(0)) : value;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">

</style>
